import api from '@/api'
const store = {
  state: {
    dataVariantItem: [],
    dataVariantCategory: [],
    pagingVariantItem: {
      page: 1,
      size: 20,
      total: 0
    },
    sortingVariantItem: {
      byField: '',
      isDesc: false
    },
    filteringVariantItem: {
      menuItemCode: null,
      category_name: null,
      is_visable: null,
      outlet_code: null
    },
    pagingVariantCategory: {
      page: 1,
      size: 20,
      total: 0
    },
    filteringVariantCategory: {
      name: ''
    }
  },

  mutations: {
    SET_VARIANTITEM: (state, payload) => {
      state.dataVariantItem = payload
    },
    SET_PAGING_PAGE_VARIANTITEM: (state, payload) => {
      state.pagingVariantItem.page = payload
    },
    SET_PAGING_TOTAL_VARIANTITEM: (state, payload) => {
      state.pagingVariantItem.total = payload
    },
    SET_SORTING_VARIANTITEM: (state, payload) => {
      state.sortingVariantItem = payload
    },
    SET_FILTERING_VARIANTITEM: (state, payload) => {
      state.filteringVariantItem = payload
    },
    SET_VARIANT_CATEGORY: (state, payload) => {
      state.dataVariantCategory = payload
    },
    SET_FILTERING_CATEGORY: (state, payload) => {
      state.filteringVariantCategory.name = payload
    },
    SET_PAGING_PAGE_CATEGORY: (state, payload) => {
      state.pagingVariantCategory.page = payload
    },
    SET_PAGING_TOTAL_CATEGORY: (state, payload) => {
      state.pagingVariantCategory.total = payload
    }
  },

  getters: {
    SortingVariantItem: state => state.sortingVariantItem,
    FilteringVariantItem: state => state.filteringVariantItem,
    PagingVariantItem: state => state.pagingVariantItem,
    GetAllVariantItem: state => state.dataVariantItem,
    GetOneVariantItem: state => id =>
      state.dataVariantItem.find(dataVariantItem => dataVariantItem.id === id),
    GetAllVariantCategory: state => state.dataVariantCategory,
    FilteringVariantCategory: state => state.filteringVariantCategory,
    PagingVariantCategory: state => state.pagingVariantCategory
  },

  actions: {
    async UpdateSortingVariantItem({ commit, dispatch }, payload) {
      commit('SET_SORTING_VARIANTITEM', { ...payload })
      dispatch('GetAllVariantItem')
    },

    async UpdateFilteringVariantItem({ commit, dispatch }, isResetField) {
      if (isResetField) {
        const {
          menuItemCode,
          outlet_code
        } = (this as any).getters.FilteringVariantItem
        const emptyFilter = {
          menuItemCode,
          category_name: null,
          is_visable: null,
          outlet_code
        }
        commit('SET_FILTERING_VARIANTITEM', emptyFilter)
      }
      commit('SET_PAGING_PAGE_VARIANTITEM', 1)
      dispatch('GetAllVariantItem')
    },

    async GetAllVariantItem({ commit, state }) {
      try {
        commit('SET_IS_FETCHING_DATA', true)
        const result = await api.GetAllVariantItem(
          state.pagingVariantItem,
          state.sortingVariantItem,
          state.filteringVariantItem
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit('SET_PAGING_TOTAL_VARIANTITEM', result.headers['data-length'])
        commit('SET_VARIANTITEM', result.data.data.data)
        return result.data.data.data
      } catch (e) {
        commit('SET_IS_FETCHING_DATA', false)
        throw e
      }
    },

    async CreateVariantItem({ dispatch }, payload) {
      try {
        const { data } = await api.CreateVariantItem(payload)
        dispatch('GetAllVariantItem')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateVariantItem({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateVariant(payload.id, payload)
        dispatch('GetAllVariantItem')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteVariantItem({ dispatch }, id) {
      try {
        const { data } = await api.DeleteVariant(id)
        dispatch('GetAllVariantItem')
        return data
      } catch (e) {
        throw e
      }
    },

    async GetAllCategoryItem({ commit, state }) {
      try {
        const result = await api.GetAllCategoryItem(
          state.pagingVariantCategory,
          state.filteringVariantCategory
        )
        commit('SET_IS_FETCHING_DATA', false)
        commit('SET_PAGING_TOTAL_CATEGORY', result.headers['data-length'])
        commit('SET_VARIANT_CATEGORY', result.data.data.data)
        return result.data.data.data
      } catch (e) {
        throw e
      }
    },
    async UpdateFilteringCategoryItem({ commit, dispatch }, isResetField) {
      if (isResetField) {
        commit('SET_FILTERING_CATEGORY', '')
      }
      commit('SET_PAGING_PAGE_CATEGORY', 1)
      dispatch('GetAllCategoryItem')
    },
    async CreateCategoryItem({ dispatch }, payload) {
      try {
        const { data } = await api.CreateVariantCategory(payload)
        dispatch('GetAllCategoryItem')
        return data
      } catch (e) {
        return e.response
      }
    },

    async UpdateCategoryItem({ dispatch }, payload) {
      try {
        const { data } = await api.UpdateVariantCategory(payload.id, payload)
        dispatch('GetAllCategoryItem')
        return data
      } catch (e) {
        return e.response
      }
    },

    async DeleteCategoryItem({ dispatch }, id) {
      try {
        const { data } = await api.DeleteVariantCategory(id)
        dispatch('GetAllCategoryItem')
        return data
      } catch (e) {
        throw e
      }
    }
  }
}

export default store
